import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout.js"
import parse from 'html-react-parser'

// import '../styles/grm-blog.scss'
// import '../styles/chatlike.scss'
// import '../styles/foundation.scss'

import GRMcontactForm from "../components/grm-contact-form.js"
import GRMbreadcrumbs from "../components/grm-breadcrumbs.js"
import SEOhead from "../components/seo.js"
import HeadCSS from "../components/headCss.js"

import {
    PrepMedia,
} from '../utils/globalUtils.js'

let currentPage = ''

const BlogPostTemplate = ({ data }) => {
    let { 
        title, 
        date, 
        author, 
        // wpautopcontent, 
        categories,
        content
    } = data.wpPost
    let langCode = data.wpPost.language.slug || 'en'
    let recentPosts = data.allWpPost.nodes
    let categoryTitle = categories.nodes[0].name
    let categoryId = categories.nodes[0].databaseId
    let categoryUri = categories.nodes[0].uri
    let elementorHF = JSON.parse(data.wp.elementorHF)
    let elementorCssKit = JSON.parse(data.wp.elementorCssKit)

    let recentsTitle

    // wpautopcontent = wpautopcontent.replace(
    //     /(href=")/gm, 
    //     'data-lang="'+ langCode +'" href="'
    // ) 

    switch ( categories.nodes[0].databaseId ) {
        case 323:
            recentsTitle = 'Recent blog posts'
            
            break
        case 327:
            recentsTitle = 'Other News/Press releases'

            break
        default:
            recentsTitle = ''
            break
    }
	const catPattern = '(?<=\{)\s*[^{]*?\"catID\":'+ categoryId +'(?=[\},])'
	const catMatch = data.wp.grmPaginationPages.match(new RegExp(catPattern, 'gm'))
	const catJson = ( catMatch ) ?
		'{'+ catMatch[0] +'}' : null
	const catUri = ( catJson ) ? 
		JSON.parse(catJson).uri : 
		categoryUri
    
    return(
        <Layout className="grm-post grm-width-wrapper"
            langCode = { langCode }
            activeKitId={elementorCssKit.activeKitId}
            headerContent={elementorHF.header[langCode].content}
            footerContent={elementorHF.footer[langCode].content}>

            <div className="elementor-section elementor-section-boxed">
                <div className="elementor-container">
                    <section className={"grm-post-content loc elementor-column "+
                            "elementor-col-66 elementor-top-column" }>
                        <div className="grm-post-content-inner">
                            <header className={"grm-post-header"}>
                                <GRMbreadcrumbs title={ categoryTitle }
                                    style={{marginTop: '-1em'}} 
                                    langCode = { langCode } uri={ catUri }/>

                                <h1 className="grm-post-title">
                                    {title}
                                </h1>
                                <div className="grm-post-meta">
                                    <time className="grm-post-time"
                                        dateTime={date}>
                                        {date}
                                    </time>
                                    <span>Posted by:</span>
                                    <span> {author.node.name}</span>
                                </div>
                                <div className="grm-post-social">
                                    <a target="_blank"
                                        rel="noreferrer"
                                        role="button"
                                        aria-label="Facebook social share"
                                        href={"https://www.facebook.com/sharer/sharer.php" +
                                            "?u=" + currentPage}>
                                        <i className="fab fa-facebook-square" style={{
                                            fontSize: '1.5rem',
                                            marginRight: '0.3em',
                                            color: '#53649A',
                                        }}></i>
                                    </a>
                                    <a target="_blank"
                                        rel="noreferrer"
                                        role="button"
                                        aria-label="LinkedIn social share"
                                        href={"https://www.linkedin.com/shareArticle?" +
                                            "mini=true&amp;url=" + currentPage}>
                                        <i className="fab fa-linkedin" style={{
                                            fontSize: '1.5rem',
                                            marginRight: '0.3em',
                                            color: '#0072b1',
                                        }}></i>
                                    </a>
                                    <a target="_blank"
                                        rel="noreferrer"
                                        role="button"
                                        aria-label="Twitter social share"
                                        href={"https://twitter.com/home?status='" + currentPage}>
                                        <i className="fab fa-twitter-square" style={{
                                            fontSize: '1.5rem',
                                            marginRight: '0.3em',
                                            color: '#00acee',
                                        }}></i>
                                    </a>
                                    <a href="#contact-us" title="Contact us"
                                            className={"grm-button elementor-button-link "+
                                                "elementor-button elementor-size-xs"}
                                            rel="nofollow">
                                        Contact us
                                    </a>
                                </div>
                            </header>
                            { parse(content, { replace: PrepMedia }) }
                        </div>
                    </section>

                    <aside className={"grm-post-sidebar loc elementor-column "+
                            "elementor-col-33 elementor-top-column" }>
                        <div className="grm-post-sidebar-inner">
                            <a href="#contact-us" title="Contact us"
                                    className={"grm-button elementor-button-link "+
                                        "elementor-button elementor-size-xs"}
                                    rel="nofollow">
                                Contact us
                            </a>
                            <div className="grm-recent-posts">
                                <h2>
                                    {recentsTitle}
                                </h2>
                                {
                                    recentPosts.map(
                                        prop => {
                                            let {id, title, uri, featuredImage} = prop
                                            let altText = ( !featuredImage ) ?
                                                'Featured image' : 
                                                featuredImage.node.altText
                                            let localFile = ( !featuredImage ) ?
                                                { publicUrl : '/grm.jpg' } : 
                                                featuredImage.node.localFile

                                            return(
                                                <article key={ id } className="grm-ptr">
                                                    <a href={ uri } title={ title }>
                                                        <img src={ localFile.publicURL }
                                                            loading="lazy"
                                                            height={75}
                                                            alt={ altText } />
                                                    </a>
                                                    <div className="grm-ptr-meta">
                                                        <h3 className="grm-ptr-heading">
                                                            <a href={ uri } 
                                                                    title={ title }>
                                                                { title }
                                                            </a>
                                                        </h3>
                                                        <time className="grm-ptr-time"
                                                                dateTime={ date }>
                                                            { date }
                                                        </time>
                                                    </div>
                                                </article>
                                            )
                                        }
                                    )
                                }
                            </div>
                            <div className="grm-disclaimer">
                                GRM is the leading provider in the US for: robust 
                                <a href="/ecm-enterprise-content-management-system/">
                                    enterprise content management system
                                </a>
                                , full suite of 
                                <a href="/edms-Electronic-Document-Management-System/">
                                    EDMS
                                </a> 
                                <a href="/document-management-software/">
                                    document management software
                                </a> 
                                and 
                                <a href="/workflow-management-software/">workflow
                                    management software
                                </a>, 
                                <a href="/document-storage-solutions-digitization-services/">
                                    document storage solutions
                                </a>, 
                                <a href="/records-management-software/">
                                    records management software
                                </a>
                                , and 
                                <a href="/document-scanning-services-near-me/">
                                    document scanning services
                                </a>
                            </div>
                        </div>
                    </aside>
                </div>
            </div>

            <GRMcontactForm langCode={langCode} />

            <style type="text/css" dangerouslySetInnerHTML={{
                __html: ".grm-post-sidebar{padding:95px 0 0 2.8rem}.grm-post-header{width:100%;margin-top:5em}.grm-post-header .grm-breadcrumbs{position:absolute;top:0}.grm-post-content{color:#525252;font-family:FuturaPT-Book,Helvetica,Arial,sans-serif;font-size:18px;min-height:750px;margin-bottom:5em}.grm-post-content blockquote:not(.elementor-blockquote){border:0;padding:0}.grm-post-content blockquote:not(.elementor-blockquote) > p{font-family:FuturaPT-Medium,Helvetica,Arial,sans-serif;font-size:24px;line-height:35px;color:#76a8e1;padding:0 25px;margin:0 25px 50px;border-left:2px solid #c1c1c1}.grm-post-title{display:block;font-family:FuturaPT-Bold,Helvetica,Arial,sans-serif;font-size:36px;margin:0 0 8px;padding:0;width:100%;letter-spacing:0;color:#c52033;text-transform:uppercase}.grm-post-meta{font-family:FuturaPT-Medium,Helvetica,Arial,sans-serif;font-size:14px;line-height:25px;margin-bottom:15px}.grm-ptr-heading,.grm-recent-posts h2{font-family:FuturaPT-Bold,Helvetica,Arial,sans-serif}.grm-post-time:after{content:'|';margin:0 5px}.grm-post-social{margin-bottom:2em}.grm-post-social svg{width:25px;height:25px;margin-right:5px}.grm-post-social svg>.facebook path{fill:red}.grm-recent-posts h2{font-size:18px;color:#c52033;margin:0 0 10px}.grm-ptr{display:flex;padding:20px 0;border-bottom:1px solid #ddd}.grm-ptr:last-child{border-bottom:0}.grm-ptr-image-wrap{width:75px;height:75px;display:block;background:#ccc}.grm-ptr-meta{width:calc(100% - 75px);padding:0 0 0 15px}.grm-ptr-heading{font-size:16px;line-height:20px;padding:0;transform:translateY(-5px);margin-bottom:-.5rem}.grm-ptr-time{font-size:14px;font-style:italic;line-height:36px}.grm-ptr>a{height:75px;width:75px;overflow:hidden;position:relative}.grm-ptr>a img{width:auto;max-width:none;position:absolute;left:50%;transform:translate(-50%)}.grm-disclaimer{font-size:14px;line-height:25px;margin:3em 0}#global-header{border-bottom:1px solid #c9c9c9}.grm-button{background:#19247b;color:#f8f8f8;border:1px solid #19247b;border-radius:.3rem;display:inline-block;font-family:FuturaPT-Medium,sans-serif;font-size:18px;letter-spacing:.5px;line-height:24px;font-weight:400;padding:.5rem 2.6rem;margin:0 0 58px -1rem;transition:border-color .3s ease-out,color .3s ease-out,background .3s ease-out}.grm-post-social .grm-button{display:none}@media screen and (max-width:767px){.grm-post-sidebar{margin:0;padding:0}.grm-post-sidebar .grm-button{display:none}.grm-post-social .grm-button{display:block;position:absolute;margin-top:-28px;right:10px}}"
            }} />

            <link rel="stylesheet" as="style"
				href="/styles/chatlike.css" />
        </Layout>
    )
}

export default BlogPostTemplate

export const Head = ({ data }) => {
    const hasFeaturedImage = ( data.wpPost.featuredImage ) ? true : false

	data.wpPost.seo.locale = ( data.wpPost.language ) ?
		data.wpPost.language.locale : 'en_US'
	data.wpPost.seo.allLangs = []
	data.wpPost.seo.transUris = []

	data.wp.languages.forEach(lang => {
		data.wpPost.seo.allLangs.push(lang.locale)
	})

	data.wpPost.translations.forEach(subItem => {
		data.wpPost.seo.transUris.push(subItem.uri)
	})

	return( 
		<>
			<SEOhead data={data.wpPost.seo} 
                hasFeaturedImage={hasFeaturedImage}
                customJsonLD={data.wpPost.customJsonLD}/>
			<HeadCSS data={data} /> 
		</>
	)
}

export const query = graphql`
    query(
        $id: String,
        $category: Int!
    ) {
        wpPost(
            id: { 
                eq: $id 
            }
        ) {
            author {
                node {
                    name
                }
            }
            categories {
                nodes {
                    databaseId
                    name
                    uri
                }
            }
            content
            customJsonLD
            date(formatString: "MMMM DD, YYYY")
            elementorCss
            featuredImage {
				node {
					uri
				}
			}
            language {
                slug
                locale
            }
            seo {
				metaDesc
				metaKeywords
				metaRobotsNofollow
				metaRobotsNoindex
				opengraphUrl
				opengraphType
				opengraphAuthor
				opengraphDescription
				opengraphImage {
					localFile {
                        publicURL
                    }
				}
				opengraphTitle
				opengraphSiteName
				opengraphPublisher
				opengraphPublishedTime
				opengraphModifiedTime
				title
				twitterDescription
				twitterTitle
                schema {
                    raw
                }
			}
            translations {
				uri
			}
            id
            title
            wpautopcontent
        }
        allWpPost(
            limit: 4
            sort: {
                date: DESC,
            }
            filter: {
                categories: {
                    nodes: {
                        elemMatch: {
                            databaseId: {
                                eq: $category
                            }
                        }
                    }
                }, 
                id: {
                    ne: $id
                }
            }
        ) {
            nodes {
                id
                title
                uri
                date
                featuredImage {
                    node {
                        altText
                        localFile {
                            publicURL
                        }
                    }
                }
            }
        }
        wp {
            elementorHF
            elementorCssKit
            languages {
				locale
			}
            grmPaginationPages
        }
    }
`